// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"a5bbe9ff","319":"14f8a4c4","353":"7253f840","667":"596e2d1c","746":"27eaf998","974":"f2334914"}[chunkId] + ".chunk.js";
};